import { v4 as uuid } from "uuid";

export const PROJECTS = [
  {
    id: uuid(),
    name: "Amtalek - Real Estate",
    desc: "A multi-vendor real estate platform built with Next.js (using Server Actions), React Hook Form, and Redux. Implemented dynamic sitemap generation and SEO optimizations to connect leads with a wide network of vendors.",
    photo: "./imgs/amtalek.png",
    demo: "https://www.amtalek.com",
    github: "",
  },
  {
    id: uuid(),
    name: "Lanacrm Website - Real Estate",
    desc: "Real-Estate Single Vendor Website, Added some features to the site, Fixed a number of software issues that were affecting the site, Arabic and English translations Fixed,Improved compatibility with different screens to ensure a smooth experience on phones and tablets.",
    photo: "./imgs/lanacrm.png",
    demo: "https://demo.lanacrm.com/ar",
    github: "",
  },
  {
    id: uuid(),
    name: "Portfolio - Bassam El‑Shoraa",
    desc: "I built and designed a responsive, interactive portfolio using React, React-Slick, and the Context API. The Medium API is integrated for dynamic content, improved performance, and image loading.",
    photo: "./imgs/portfolio-bassam.png",
    demo: "https://bassam-portfolio.netlify.app/",
    github: "https://github.com/Ali-El-Shoraa/portfolio-bassam",
  },
  {
    id: uuid(),
    name: "Tresor Café",
    desc: "I designed a fully responsive website for Tresor Café, developed using HTML, CSS, and JavaScript. It features an interactive food and drink menu, Instapay integration for online payments, and a QR code for instant WiFi access.",
    photo: "./imgs/tresor-cafe.png",
    demo: "https://treasor-menu.netlify.app/",
    github: "",
  },

  {
    id: uuid(),
    name: "Ayo 7 - Ecommerce",
    desc: "A Front-End e-commerce developed using Next.js, Tailwind CSS, and ShadCN UI, hosted on Vercel.",
    photo: "./imgs/ayo7.png",
    demo: "https://ayo-7.netlify.app/en",
    github: "",
  },
  {
    id: uuid(),
    name: "Dashboard",
    desc: "An interactive dashboard project built with React and TypeScript, using MUI, Recharts, and MUI DataGrid to display data and charts, with smooth navigation using React Router DOM. using React, TypeScript, Vite, Material UI, Emotion, Sass, MUI DataGrid, Recharts, React Router DOM",
    photo: "./imgs/dashboard-react.png",
    demo: "https://react-ts-dashboard.netlify.app/",
    github: "",
  },
  // {
  //   id: uuid(),
  //   name: "Dashboard",
  //   desc: "Built a fully responsive Next.js + React admin dashboard that un e-commerce analytics, finance KPIs, communication tools, and project management widgets in a single, modern UI, Implemented real-time, interactive charts and transaction tables using shadcn UI and Tailwind CSS, enabling instant insight into monthly revenue, visitor trends, and order status, Added draggable calendar events and customizable to-do lists to streamline scheduling and daily task tracking across desktop and mobile devices.",
  //   photo: "./imgs/dashboard.png",
  //   demo: "https://dashboard-next-shadcn-xi.vercel.app/",
  //   github: "",
  // },
  {
    id: uuid(),
    name: "Chat App - Realtime",
    desc: "Developed a real-time chat application using the MERN stack and Socket.IO, enabling users to communicate instantly with secure authentication, image sharing, and responsive UI.",
    photo: "./imgs/chat-app-realtime.png",
    demo: "",
    github: "https://github.com/Ali-El-Shoraa/chat-app-realtime",
  },
  // {
  //   id: uuid(),
  //   name: "Amtalek - Real Estate",
  //   desc: "HEXASHOP is an e-commerce application, built using Next.js and Tailwind CSS, with API integration to provide a seamless user experience. The application features an attractive and easy-to-use user interface, and high performance thanks to Next.js optimizations. For users to browse products,.",
  //   photo: "./imgs/amtalek.png",
  //   demo: "https://www.amtalek.com",
  //   github: "",
  // },
  // {
  //   id: uuid(),
  //   name: "Home Advisor - Real Estate",
  //   desc: "HEXASHOP is an e-commerce application, built using Next.js and Tailwind CSS, with API integration to provide a seamless user experience. The application features an attractive and easy-to-use user interface, and high performance thanks to Next.js optimizations. For users to browse products,.",
  //   photo: "./imgs/home-advisor.png",
  //   demo: "https://iconicegypt.net/ar",
  //   github: "",
  // },

  // {
  //   id: uuid(),
  //   name: "Portfolio - Bassam",
  //   desc: "HEXASHOP is an e-commerce application, built using Next.js and Tailwind CSS, with API integration to provide a seamless user experience. The application features an attractive and easy-to-use user interface, and high performance thanks to Next.js optimizations. For users to browse products,.",
  //   photo: "./imgs/portfolio-bassam.png",
  //   demo: "https://bassam-portfolio.netlify.app/",
  //   github: "https://github.com/Ali-El-Shoraa/portfolio-bassam",
  // },
  // {
  //   id: uuid(),
  //   name: "Tresor Café",
  //   desc: "A fully responsive web application designed for Tresor Café, showcasing menu items and enabling online payments.",
  //   photo: "./imgs/tresor-cafe.png",
  //   demo: "https://treasor-menu.netlify.app/",
  //   github: "",
  // },

  // {
  //   id: uuid(),
  //   name: "Onlin Store",
  //   desc: "HEXASHOP is an e-commerce application, built using Next.js and Tailwind CSS, with API integration to provide a seamless user experience. The application features an attractive and easy-to-use user interface, and high performance thanks to Next.js optimizations. For users to browse products,.",
  //   photo: "./imgs/onlin-store-next.png",
  //   demo: "https://onlin-store-next.vercel.app/",
  //   github: "https://github.com/Ali-El-Shoraa/onlin-store-next",
  // },
  {
    id: uuid(),
    name: "Netflix Clone",
    desc: "I designed a Netflix-like website using HTML, SCSS, ReactJs, react-slick, and Firebase/Auth. The site includes an attractive and responsive user interface, and allows users to easily browse and watch a variety of digital content. Implemented authentication system using Firebase/Auth to provide a secure and reliable login experience.",
    photo: "./imgs/netflix-clone.png",
    demo: "https://nelflix-clone.netlify.app/",
    github: "https://github.com/Ali-El-Shoraa/netflix-clone",
  },
  {
    id: uuid(),
    name: "Recipes App",
    desc: "I designed a recipe web application using HTML, SCSS, Tailwind, and ReactJs. The app allows users to easily browse and search for a wide range of recipes. The user interface is attractively and flexiblely designed to provide a pleasant and comfortable user experience.",
    photo: "./imgs/recipes-app.png",
    demo: "https://ali-el-shoraa.github.io/recipes-app/",
    github: "https://github.com/Ali-El-Shoraa/recipes-app",
  },
  // {
  //   id: uuid(),
  //   name: "Youtyube Clone",
  //   desc: "I designed a YouTube-like website using HTML, SCSS, ReactJs, and Material-UI. The site offers an experience similar to YouTube in viewing videos and browsing content, while using a sophisticated and attractive user interface with modern web technologies.",
  //   photo: "./imgs/yu1.jpg",
  //   demo: "https://youtyube-videos-clone.netlify.app/",
  //   github: "https://github.com/Ali-El-Shoraa/youtube-clone",
  // },
  {
    id: uuid(),
    name: "Portfolio Dj",
    desc: "Another copy of my personal portfolio by using Database (SQLite), Python (Django) and JavaScript.",
    photo: "./imgs/portfolio-dj.png",
    demo: "https://portfolio-dj-eight.vercel.app/",
    github: "https://github.com/Ali-El-Shoraa/portfolio-dj",
  },
  // {
  //   id: uuid(),
  //   name: "Weather App",
  //   desc: "This project showcases a basic weather application built using Angular and SCSS. It allows users to search for any city and retrieve its current weather information, including temperature, humidity, wind speed, and weather description. The app features a clean and responsive design, adhering to modern web development standards.",
  //   photo: "./imgs/weather-app-ang.png",
  //   demo: "https://weather-app-ang-gray.vercel.app/",
  //   github: "https://github.com/Ali-El-Shoraa/weather-app-ang",
  // },
  // {
  //   id: uuid(),
  //   name: "Tic-Tac-Toe",
  //   desc: "I designed a Tic Tac Toe game using HTML, CSS3, and JavaScript. The game provides an interactive and fun experience for players where they can compete against each other in a classic and exciting game.",
  //   photo: "./imgs/tic-tac-toe-oop.png",
  //   demo: "https://ali-el-shoraa.github.io/tic-tac-toe-oop/",
  //   github: "https://github.com/Ali-El-Shoraa/tic-tac-toe-oop",
  // },
  // {
  //   id: uuid(),
  //   name: "Mp3 Audio",
  //   desc: "I designed an MP3 application using HTML, SCSS, and ReactJS. The app provides a comfortable listening experience to users with an easy-to-use interface and innovative design.",
  //   photo: "./imgs/react-mp3-app.png",
  //   demo: "https://ali-el-shoraa.github.io/react-mp3-app/",
  //   github: "https://github.com/Ali-El-Shoraa/react-mp3-app",
  // },
  // {
  //   id: uuid(),
  //   name: "Personal Portfolio",
  //   desc: "I designed a personal website (Portfolio) using HTML, SCSS, and ReactJs. The website displays information about me, my previous projects, my technical skills, and my CV. The user interface is designed in a simple and attractive style to display a comprehensive and attractive summary of my skills and experience in the field of web development.",
  //   photo: "./imgs/my-portfolio.png",
  //   demo: "https://ali-el-shoraa.github.io/my-portfolio/",
  //   github: "https://github.com/Ali-El-Shoraa/my-portfolio",
  // },
  // {
  //   id: uuid(),
  //   name: "Calculator Age",
  //   desc: "I designed a Netflix-like website using HTML, SCSS, ReactJs, react-slick, and Firebase/Auth. The site includes an attractive and responsive user interface, and allows users to easily browse and watch a variety of digital content. Implemented authentication system using Firebase/Auth to provide a secure and reliable login experience.",
  //   photo: "./imgs/calculator-age.png",
  //   demo: "https://ali-el-shoraa.github.io/calculator-age-task/",
  //   github: "https://github.com/Ali-El-Shoraa/calculator-age-task",
  // },
  // {
  //   id: uuid(),
  //   name: "Calculator",
  //   desc: "I designed a Netflix-like website using HTML, SCSS, ReactJs, react-slick, and Firebase/Auth. The site includes an attractive and responsive user interface, and allows users to easily browse and watch a variety of digital content. Implemented authentication system using Firebase/Auth to provide a secure and reliable login experience.",
  //   photo: "./imgs/calculator-class.png",
  //   demo: "https://ali-el-shoraa.github.io/calculator-class/",
  //   github: "https://github.com/Ali-El-Shoraa/calculator-class",
  // },
  // {
  //   id: uuid(),
  //   name: "Tip Calculator App",
  //   desc: "I designed a tip calculator app using HTML, CSS3, and JavaScript. The application helps users calculate tips quickly and easily, as they can enter the invoice value and the required tip percentage to calculate the total amount, including the tip. The interface is designed simple and user-friendly to effectively meet the needs of users.",
  //   photo: "./imgs/tip-calculator-app-main.png",
  //   demo: "https://ali-el-shoraa.github.io/tip-calculator-app-main/",
  //   github: "https://github.com/Ali-El-Shoraa/tip-calculator-app-main",
  // },
  {
    id: uuid(),
    name: "Template Elzero",
    desc: "I designed a website using HTML and CSS3 to provide an attractive and visual user experience. The site features a clean and attractive design that enhances interaction with the content in a simple and innovative way.",
    photo: "./imgs/HTML_And_CSS_Template_Elzero1.png",
    demo: "https://ali-el-shoraa.github.io/HTML_And_CSS_Template_Elzero/",
    github: "https://github.com/Ali-El-Shoraa/HTML_And_CSS_Template_Elzero",
  },

  // {
  //   id: uuid(),
  //   name: "Dashbord Amtalek",
  //   desc: "HEXASHOP is an e-commerce application, built using Next.js and Tailwind CSS, with API integration to provide a seamless user experience. The application features an attractive and easy-to-use user interface, and high performance thanks to Next.js optimizations. For users to browse products,.",
  //   photo: "./imgs/onlin-store-next.png",
  //   demo: "https://onlin-store-next.vercel.app/",
  //   github: "https://github.com/Ali-El-Shoraa/onlin-store-next",
  // },
];
